// A reel's YouTube video id (ReelCard.video_id, API-243) → the URLs the website needs.
// Pure — unit-tested. Nothing is hosted here: the poster is YouTube's own still and the
// player is the privacy-enhanced youtube-nocookie embed, which loads only once a reel is
// on screen. Autoplay is muted (browsers allow nothing else without a gesture) and the
// `playlist=` trick is how a single video loops.
export interface ReelEmbed {
  poster: string;
  /**
   * The muted, looping, chrome-less player for the vertical viewer. With `origin` (the page's
   * own origin) the player accepts postMessage commands from it — the tap-to-pause, ±10s and
   * 2× controls in reel-player.ts — and nothing else changes.
   */
  embed: (opts?: { muted?: boolean; origin?: string; start?: number }) => string;
  /** Where "Watch on YouTube" goes. */
  watch: string;
}

/** Where the player is served from — the only origin reel-player.ts talks to. */
export const PLAYER_ORIGIN = 'https://www.youtube-nocookie.com';

const ID = /^[A-Za-z0-9_-]{11}$/;

export function reelEmbed(videoId: string): ReelEmbed | null {
  if (!ID.test(videoId)) return null;
  return {
    poster: `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`,
    embed: ({ muted = true, origin, start } = {}) =>
      `${PLAYER_ORIGIN}/embed/${videoId}?autoplay=1&mute=${muted ? 1 : 0}&loop=1&playlist=${videoId}&controls=0&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3` +
      (origin ? `&enablejsapi=1&origin=${encodeURIComponent(origin)}` : '') +
      (start && start >= 1 ? `&start=${Math.floor(start)}` : ''),
    watch: `https://www.youtube.com/shorts/${videoId}`,
  };
}
